import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0F0F0F",
      "fill-rule": "evenodd",
      d: "M12 16.556 18 21V5H6v16z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }